import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";

const storesApi = factory.get("stores");

const initialState = {
  stores: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      search: "",
      is_active: "all",
    },
  },
  store: {
    form: {
      id: "",
      name: "",
      address: "",
      status: true,
      is_main: 0,
      damaged_store_id: null,
    },
    dialog: false,
    loading: false,
    errors: {},
  },
};

export const storesSlice = createSlice({
  name: "stores",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setStores: (state, action) => {
      state.stores.data = action.payload.data.data;
      state.stores.total = action.payload.data.total;
    },
    setStore: (state, action) => {
      state.store.form = { ...action.payload.data };
    },
    resetForm: (state, action) => {
      state.store.form = initialState.store.form;
    },
    setFilters: (state, { payload }) => {
      state.stores.filters = {
        ...state.stores.filters,
        ...payload,
      };
    },
    setDialog: (state, { payload }) => {
      if (payload) {
        Object.keys(state.store.form).forEach((key) => {
          state.store.form[key] = payload[key];
        });
      } else {
        state.store.form = initialState.store.form;
      }
      state.store.dialog = !state.store.dialog;
    },
    resetFilters: (state) => {
      state.stores.filters = {
        ...initialState.stores.filters,
        is_active: "all",
      };
    },
    clearStores: (state) => {
      state.stores = {
        ...initialState.stores,
        filters: {
          ...initialState.stores.filters,
          is_active: "all",
        },
      };
    },
  },
});

export const {
  setLoading,
  setStores,
  setStore,
  setFilters,
  resetFilters,
  setDialog,
  resetForm,
  clearStores,
} = storesSlice.actions;

export default storesSlice.reducer;

//axios
const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().stores.stores.filters;
    dispatch(setLoading("stores"));
    const res = await storesApi.index(filters);
    dispatch(setStores(res));
    dispatch(setLoading("stores"));
  } catch (err) {
    dispatch(setLoading("stores"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const showById = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("store"));
    const res = await storesApi.showById(id);
    dispatch(setStore(res));
    dispatch(setLoading("store"));
  } catch (err) {
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const create = (data) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("store"));
    await storesApi.create(data);
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "success",
        message: "Store Created Successfully",
      })
    );
    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const update = (data) => async (dispatch, getState) => {
  try {
    const { id } = getState().stores.store.form;
    dispatch(setLoading("store"));
    await storesApi.update(id, data);
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "success",
        message: "Store Updated Successfully",
      })
    );
    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

const Delete = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("store"));
    await storesApi.delete(id);
    dispatch(
      showNotification({
        type: "success",
        message: "Store Deleted Successfully",
      })
    );
    dispatch(index());
    dispatch(setLoading("store"));
  } catch (err) {
    dispatch(setLoading("store"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

export const Stores = {
  index,
  showById,
  create,
  update,
  Delete,
};
